import { Component, Input } from '@angular/core';
import { IUser } from '../../models/be/user';
import { RoleToTranslation } from '../../enums/userRole.enum';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from "../../modules/material.module";

@Component({
  selector: 'user-section-sidenav',
  templateUrl: './user-section-sidenav.component.html',
  styleUrls: ['./user-section-sidenav.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    MaterialModule
  ]
})
export class UserSectionSidenavComponent {
  @Input() userData?: IUser;
  @Input() collapsed: boolean = false;

  get roleTranslationKey(): string {
    const role = this.userData?.role;
    const label = role ? RoleToTranslation[role] : undefined;
    return label ? 'PAGES.USERS.ROLES.' + label : role || '';
  }

  getInitials(name: string = "", lastname: string = ""): string {
    const n = name ? name.charAt(0).toUpperCase() : '';
    const l = lastname ? lastname.charAt(0).toUpperCase() : '';
    return n + l;
  }

}
